import { render } from "./ThemeOptionsAPIProvider.vue?vue&type=template&id=2cbce25a"
import script from "./ThemeOptionsAPIProvider.vue?vue&type=script&lang=js"
export * from "./ThemeOptionsAPIProvider.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__